import { BrandliveEvent } from "../types/working-model";
import { removeStorageItem } from "./local-storage";
import { removeSessionStorageItem } from "./session-storage";
import { getSSOLogoutUrl } from "./sso-utils";

// this function will be moved into a larger registration utility file once registration refactor is completed
export const deregister = (eventBundle: BrandliveEvent): void => {
	Object.keys(localStorage)
		.filter(key => key.startsWith('poll-answer_type'))
		.forEach(key => removeStorageItem(key));
	removeStorageItem(`reg.${eventBundle?.uuid}`);
	removeStorageItem(`registration-step-${eventBundle?.uuid}`);
	removeStorageItem(`allowed.${eventBundle?.uuid}`);
	removeStorageItem('bl-profile');
	removeStorageItem('Bl-Profile-Token');
	removeStorageItem(`should-cont-reg-${eventBundle?.uuid}`);
	removeStorageItem(`all-steps-completed.${eventBundle?.event}`);
	removeStorageItem(`pageSession.${eventBundle?.event}`);
	removeSessionStorageItem(`live_analytic_triggered.${eventBundle?.event}`);

	const logoutUrl = getSSOLogoutUrl(eventBundle);

	if (logoutUrl) {
		window.location.href = logoutUrl;
	} else {
		window.location.reload();
	}
};
